import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import ApiService from "../../../services/apiService";
import { toast } from "react-toastify";
import Update from "../../table/Update";


const UpdateWua = ()=>{

    const {Id} = useParams();
    const navigate = useNavigate();
  
    const [ data,setData] = useState<any>([])
    
    const initialData ={
        HeadQuaterName:data?.headQuaterName,
        
    }
   
    useEffect(() => {
      const fetchWua = async () => {
         try{
           const response = await ApiService.axiosApi(`/wua/${Id}`,{
              method: 'GET',
           });
           if(response.success){
           
            setData(response.data)
              
           }
         }catch(error: any){
          toast.error(error.message);
         }
      }
      if(Id) fetchWua();
    }, [Id,  navigate]);
  
      
      const onSubmit = async (data :any) => {
        try{
        
          const response = await ApiService.axiosApi(`/wua/${Id}`,{
            method: 'PUT',
            data: data,
          })
          if(response.success){
            toast.success("wua updated successfully");
            navigate(-1);
          }else{
            toast.error(response.message);
          }
            
        }catch(error: any){
          toast.error(error.message);
        }
      }

    return(
         <>
                <Update
           title={'Update Wua'}
           parentTitle = {'Wua'}

           fields={
             [
                {
                  name:"HeadQuaterName",
                  label : "Wua",
                  type : "text"
                },
                
             ]
           }
           onSubmit={onSubmit}
           initialData ={initialData}
         />
         </>
    )
}

export default UpdateWua